import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    selectFieldClass: String,
    toggleOnClass: String,
    toggleOffClass: String,
    toggleAlwaysOffClass: String,
    toggleAlwaysOnClass: String,
    toggleOptionClass: String
  };

  connect() {
    // trigger logic on initial load if any radio button is pre-selected
    const selected = $('input.' + this.selectFieldClassValue + ':checked');
    if (selected.length > 0) {
      this.toggleTarget();
    }
  }  

  // toggles visibility of dom elements dependent on selected radio button.
  // values: selectFieldClass, toggleOnClass, toggleOffClass, toggleOptionClass.
  toggleTarget(event) {
    var selected = $('input.' + this.selectFieldClassValue + ':checked');
    var target_on = $('.' + this.toggleOnClassValue);
    var target_off = $('.' + this.toggleOffClassValue);
    var target_always_off = $('.' + this.toggleAlwaysOffClassValue);
    var target_always_on = $('.' + this.toggleAlwaysOnClassValue);
    var toggle_option_class = this.toggleOptionClassValue;

    if (selected && toggle_option_class) {
      const toggle_on = selected.hasClass(toggle_option_class);

      this.toggleVisibilityAndState(target_on, toggle_on);
      this.toggleVisibilityAndState(target_off, !toggle_on);
      this.toggleVisibilityAndState(target_always_off, false);
      this.toggleVisibilityAndState(target_always_on, true);    
      
      // var toggle_on = selected.hasClass(toggle_option_class);

      // if (target_on) {
      //   toggle_on ? target_on.removeClass('hide') : target_on.addClass('hide');
      // }

      // if (target_off) {
      //   toggle_on ? target_off.addClass('hide') : target_off.removeClass('hide');
      // }

      // if (target_always_off) {
      //   target_always_off.addClass('hide');
      // }

      // if (target_always_on) {
      //   target_always_on.removeClass('hide');
      // }      
    }
  }

  toggleVisibilityAndState($element, show) {
    if (!$element) return;
  
    if (show) {
      $element.removeClass('hide');
      $element.find('input, select, textarea, button').prop('disabled', false);
    } else {
      $element.addClass('hide');
      $element.find('input, select, textarea, button').prop('disabled', true);
    }
  }  
}